<template>
  <check-base-layout
    :pagetitle="pagetitle"
    :check-info-data="{}"
  >
    <template>
      <div>
        <customer-module :customer-data="{}"></customer-module>
      </div>
      <check-module :title="`收款信息`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">
                收款编号：
              </div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">
                收款方式：
              </div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">
                收款类型：
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div>票据金额：</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
      <check-module :title="`收款信息`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">
                承兑编号：
              </div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">
                出票单位：
              </div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">
                出票行：
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div>出票日期：</div>
            </el-col>
            <el-col :span="8">
              <div>到期日期：</div>
            </el-col>
            <el-col :span="8">
              <div>付款凭证：</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
    </template>
    <template #checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'

export default {
  name: 'ticketreceiptCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '承兑汇票收款审批'
    }
  }
}
</script>

<style scoped>

</style>
